// extracted by mini-css-extract-plugin
export default {"overlay":"oB-z","bodyOpen":"pB-z","content":"qB-z","header":"rB-z","close":"sB-z","closeNoHeading":"tB-z"};